// extracted by mini-css-extract-plugin
export var checkbox = "_95-0";
export var circle = "_95-3";
export var horizontalContainer = "_95-7";
export var sm = "_95-5";
export var switch0 = "_95-2";
export var switchDisabled = "_95-8";
export var switchEnabled = "_95-1";
export var textSwitchContainer = "_95-9";
export var textSwitchOption = "_95-a";
export var textSwitchOptionSelected = "_95-b";
export var verticalContainer = "_95-6";
export var xs = "_95-4";